import FilterForm from '../../../components/forms/FilterForm';
import { CrudFilters, HttpError } from '@refinedev/core';
import { Form, Input, Select, Space, Table } from 'antd';
import { IComment } from 'interfaces/comments';
import { ListLayout } from '../../../components/layout/layout/ListLayout';
import { SearchOutlined } from '@ant-design/icons';
import { ShowButton, TextField, useTable } from '@refinedev/antd';
import { formatDate } from 'services/date';

const translateParentKind = (parentKind: string) => {
  switch (parentKind) {
    case 'content': {
      return 'Na Aula';
    }

    case 'course': {
      return 'No Curso';
    }

    case 'comment': {
      return 'Resposta de comentário';
    }

    default: {
      return parentKind;
    }
  }
};

interface IFilter {
  parent_kind: string;
  email: string;
}

export const CommentsList = () => {
  const { tableProps, searchFormProps } = useTable<
    IComment,
    HttpError,
    IFilter
  >({
    onSearch: params => {
      const filters: CrudFilters = [];
      const { email, parent_kind } = params;

      filters.push(
        {
          field: 'filter[email]',
          operator: 'eq',
          value: email
        },
        {
          field: 'filter[parent_kind]',
          operator: 'eq',
          value: parent_kind
        }
      );

      return filters;
    }
  });

  return (
    <ListLayout title="Comentários" canCreate={false}>
      <FilterForm searchFormProps={searchFormProps}>
        <Form.Item name="email" className="lg:col-span-2">
          <Input placeholder="E-mail do aluno" suffix={<SearchOutlined />} />
        </Form.Item>

        <Form.Item name="parent_kind">
          <Select placeholder="Localização" allowClear>
            <Select.Option value="content">Na Aula</Select.Option>
            <Select.Option value="course">No Curso</Select.Option>
            <Select.Option value="comment">
              Resposta de comentário
            </Select.Option>
          </Select>
        </Form.Item>
      </FilterForm>

      <Table {...tableProps} rowKey="id">
        <Table.Column
          dataIndex="user"
          key="user"
          title="Aluno"
          render={(user: IComment['user']) => (
            <Space direction="vertical" size={0}>
              <TextField value={user?.full_name_or_name ?? '--'} />
              {user?.email && (
                <TextField
                  style={{ fontSize: 12, color: '#8c8c8c' }}
                  value={`E-mail: ${user.email}`}
                />
              )}
            </Space>
          )}
        />
        <Table.Column
          dataIndex="parent_kind"
          key="parent_kind"
          title="Localização"
          render={value => <TextField value={translateParentKind(value)} />}
        />
        <Table.Column
          dataIndex="text"
          key="text"
          title="Texto"
          render={value => <TextField value={value} />}
        />
        <Table.Column
          dataIndex="created_at"
          key="created_at"
          title="Data de envio"
          render={value => <TextField value={formatDate(value)} />}
        />
        <Table.Column<IComment>
          title="Ações"
          dataIndex="actions"
          align="center"
          width={80}
          render={(_, record) => {
            return (
              <Space>
                <ShowButton hideText size="small" recordItemId={record.id} />
              </Space>
            );
          }}
        />
      </Table>
    </ListLayout>
  );
};
